import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@mdi/font/css/materialdesignicons.css'
import de from 'vuetify/es5/locale/de'
import fr from 'vuetify/es5/locale/fr'
import it from 'vuetify/es5/locale/it'
import en from 'vuetify/es5/locale/en'

Vue.use(Vuetify)

export default new Vuetify({
  options: {
    customProperties: true
  },
  iconfont: 'mdi',
  lang: {
    locales: { de, fr, it, en }
  },
  theme: {
    themes: {
      light: {
        selection: {
          base: '#BBDEFB'
        },
        primary: {
          base: '#333333',
          darken1: '#000000', // black
          lighten1: '#808080', // grey
          lighten2: '#D3D3D3', // lightgrey
          lighten3: '#E4E4E4', // lightgrey
          lighten4: '#F5F5F5', // whitesmoke
          lighten5: '#FAFAFA' // white
        },
        secondary: '#999999',
        accent: {
          base: '#4d4d4d',
          darken1: '#3388FF',
          lighten1: '#BBDEFB'
        },
        error: '#f44336',
        info: '#6A8817',
        success: '#16c800',
        warning: '#ffe400',

      }
    }
  }
})
